import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import FullTable from 'src/common/components/FullTable';
import { columnsVersions } from './utils/list_data';

const FileVersions = ({ open, setClose, allFiles, nameFileDetail, onDownload }) => {
	const [versions, setVersions] = useState([]);

	useEffect(() => {
		let files = allFiles.filter((e) => {
			return e.nombre === nameFileDetail;
		});

		let getOrder = files.sort((a, b) => {
			return Number(a.versionArchivo) - Number(b.versionArchivo);
		});

		setVersions(getOrder);
	}, [nameFileDetail, allFiles]);

	return (
		<BaseModal
			open={open}
			onClose={setClose}
			onCancel={setClose}
			maxWidth="md"
			cancelLabel="cerrar"
			mainText="Versiones del archivo"
		>
			<FullTable
				title={'Archivo: ' + nameFileDetail}
				items={versions}
				columns={columnsVersions(onDownload)}
			/>
		</BaseModal>
	);
};

export default FileVersions;
